/* si-cart-delivery.js — 2026-10-14, checkout test F1.
   The product page's "Standard Shipping / Pick up in store" toggle is saved on the cart line
   (properties[shiping_method]), but the Zapiet widget in the cart drawer and on the cart page still opened
   with no tile chosen, so the first Check out tap only showed "Please select a delivery option".
   This reads the choice that snippets/si-delivery-choice.liquid prints into data-si-delivery-choice
   (on the drawer form and the cart page form) and presses the matching Zapiet tile for the shopper.
   It clicks the tile that is really on the page rather than calling Zapiet's JS API: the theme renders the
   drawer twice on its first open (add response, then the drawer's own fetch), Zapiet mounts a widget each
   time, and the API functions on window.Zapiet can belong to the discarded first widget. A click goes to
   the live one and does everything a tap does: _ZapietId line property, Checkout-Method cart attributes,
   button enabled, checkout URL built. Store Pickup opens Zapiet's store list on its default store; the
   shopper still picks the boutique there.
   Rules: waits until the widget markup has stood still for 0.4 s; a tile the shopper pressed by hand is
   remembered and put back after every re-render of the same cart (Zapiet itself forgets it when the drawer
   re-renders after a quantity change), until a new line is added (then the newest product-page choice
   wins); at most four clicks, one per second, per attempt. Does nothing when Zapiet is absent or hides
   its tiles (gift-card-only carts). Loaded deferred from sections/header.liquid. Remove the script tag
   to turn it off.
   2026-10-14 (Peter: the drawer's tiles should match the product page): the tiles are restyled to the
   product-page toggle by assets/si-cart-delivery.css, and this script rewrites Zapiet's labels ("Shipping",
   "Store Pickup") to the product page's words ("Standard Shipping", "Pick up in store") every time Zapiet
   renders or re-renders them (LABELS below; the same words can be set once in Zapiet's own settings, see the
   Katie checklist, after which this map simply finds nothing to change). The tile lookup is by Zapiet's icon
   class first, so renaming the text does not affect the pre-selection. */
(function () {
  'use strict';
  var timer = null;
  var appliedLine = null; // cart line key the last pre-selection was made for
  var manual = { method: null, line: null }; // the shopper's own tile press, and the cart line it was made on
  var seenApp = null, seenAt = 0, lastClick = 0, clicks = 0;
  // Zapiet label -> the product page's label (snippets/buy-buttons-v2.liquid). Keys are matched case-insensitively.
  var LABELS = { 'shipping': 'Standard Shipping', 'store pickup': 'Pick up in store', 'pickup': 'Pick up in store', 'in-store pickup': 'Pick up in store' };

  // Rewrite the tile labels in place. Idempotent and cheap, so it is safe to call on every mutation.
  function relabel() {
    var names = document.querySelectorAll('#storePickupApp .checkoutMethodName'), i, want;
    for (i = 0; i < names.length; i++) {
      want = LABELS[names[i].textContent.trim().toLowerCase()];
      if (want && names[i].textContent !== want) names[i].textContent = want;
    }
  }

  function target() {
    var el = document.querySelector('[data-si-delivery-choice]');
    if (!el) return null;
    var method = el.getAttribute('data-si-delivery-choice');
    if (method !== 'shipping' && method !== 'pickup') return null;
    return { method: method, line: el.getAttribute('data-si-delivery-line') || '' };
  }

  function heading(method) {
    try {
      var cfg = window.ZapietCachedSettings && window.ZapietCachedSettings.cached_config;
      var t = cfg && cfg.translations && cfg.translations[method];
      return (t && t.heading) || (window.ZapietMethods && window.ZapietMethods[method] && window.ZapietMethods[method].name) || '';
    } catch (e) { return ''; }
  }

  // The tile for a method: by Zapiet's icon class (shippingIcon / pickupIcon), else by its heading text.
  function findTile(tiles, method) {
    var i, text = heading(method).trim().toLowerCase();
    for (i = 0; i < tiles.length; i++) if (tiles[i].querySelector('.' + method + 'Icon')) return tiles[i];
    if (text) for (i = 0; i < tiles.length; i++) if (tiles[i].textContent.trim().toLowerCase() === text) return tiles[i];
    return null;
  }

  function methodOf(tile) {
    var methods = ['shipping', 'pickup', 'delivery'], i;
    for (i = 0; i < methods.length; i++) if (findTile([tile], methods[i]) === tile) return methods[i];
    return null;
  }

  // A real press on a tile (mouse, touch or keyboard; isTrusted rules out this script's own clicks).
  function remember(event) {
    if (!event.isTrusted) return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    var tile = event.target && event.target.closest && event.target.closest('#storePickupApp .checkoutMethod');
    if (!tile) return;
    var method = methodOf(tile), want = target();
    if (method) { manual.method = method; manual.line = want ? want.line : ''; }
  }

  // Returns true when there is nothing more to do (done, or not applicable).
  function apply() {
    var want = target();
    var app = document.getElementById('storePickupApp');
    var tiles = app ? app.querySelectorAll('.checkoutMethod[aria-pressed]') : [];
    if (!tiles.length) return false;
    relabel();
    if (!want) return true;
    var now = Date.now();
    if (app !== seenApp) { seenApp = app; seenAt = now; return false; } // fresh render: let it settle
    if (now - seenAt < 400) return false;
    var method = (manual.method && manual.line === want.line) ? manual.method : want.method;
    var tile = findTile(tiles, method);
    if (!tile) return true; // method switched off in Zapiet
    if (tile.getAttribute('aria-pressed') === 'true') { appliedLine = want.line; return true; }
    var pressed = false, i;
    for (i = 0; i < tiles.length; i++) if (tiles[i].getAttribute('aria-pressed') === 'true') pressed = true;
    if (pressed && appliedLine === want.line) return true; // the shopper changed the tile by hand; respect it
    if (now - lastClick < 1000) return false;
    if (clicks >= 4) return true;
    tile.click();
    lastClick = now;
    clicks += 1;
    appliedLine = want.line;
    return false; // keep polling until the tile shows as pressed
  }

  // Zapiet mounts its tiles a moment after the drawer (re)renders, so poll briefly rather than guess.
  function attempt() {
    var tries = 0;
    clicks = 0;
    clearInterval(timer);
    timer = setInterval(function () {
      tries += 1;
      var done = false;
      try { done = apply(); } catch (e) { done = true; }
      if (done || tries >= 48) clearInterval(timer); // up to 12 s
    }, 250);
  }

  document.addEventListener('click', remember, true);
  document.addEventListener('keydown', remember, true);
  ['cartdrawer:opened', 'cart:updated', 'ajaxProduct:added', 'page:loaded'].forEach(function (name) {
    document.addEventListener(name, attempt);
  });
  // The drawer is a <details>; opening it from the cart icon fires toggle but no cart event.
  document.addEventListener('toggle', function (event) {
    if (event.target && event.target.closest && event.target.closest('cart-drawer') && event.target.open) attempt();
  }, true);
  // Every drawer and cart-page re-render (add, quantity change, remove) replaces the markup.
  var watch = function (id) {
    var el = typeof id === 'string' ? document.getElementById(id) : id;
    if (!el || !window.MutationObserver) return;
    new MutationObserver(attempt).observe(el, { childList: true });
    // Zapiet mounts and re-renders its tiles deeper inside (the drawer footer, the cart page's button row):
    // keep the product-page labels on them whenever that happens, without waiting for the next poll.
    new MutationObserver(relabel).observe(el, { childList: true, subtree: true });
  };
  watch('mini-cart');
  watch('main-cart-items');
  watch(document.querySelector('.cart__footer-wrapper')); // cart page: Zapiet mounts in the footer's button row
  if (window.ZapietEvent && typeof window.ZapietEvent.listen === 'function') {
    ['widget_loaded', 'widget_restored'].forEach(function (name) {
      try { window.ZapietEvent.listen(name, attempt); } catch (e) { /* older Zapiet build */ }
    });
  }
  attempt();
})();

/* 2026-10-26 phone checkout fix (R41 sales fix 4, Website Code). Three things the 21 and 26 Oct phone tests found in
   the cart drawer and on the cart page, all caused by the Zapiet pickup app's checkout handling, fixed here on the
   theme side without touching the app:
   1. Zapiet adds skip_shopify_pay=true to every checkout request, which Shopify turns into skip_shop_pay=true: a
      returning Shop Pay shopper never gets the one-tap return and lands on the full form instead. For the Standard
      Shipping method that parameter does nothing useful, so it is removed; pickup keeps it, because Zapiet
      pre-fills the store address on the pickup checkout and a one-tap Shop Pay checkout would ship to the home address.
   2. Zapiet sends locale=en-CA on pickup checkouts (its pickup language code), so the checkout opened in Canadian
      English. The locale is forced to the shop's own (Shopify.locale, "en").
   3. Zapiet swallows a Check out tap while it is still loading or busy (its click handler calls preventDefault and
      returns), so for the first 2 to 4 seconds after the drawer opens, and sometimes later, the button does nothing
      and shows nothing. The button now shows a waiting state until Zapiet reports ready, a tap made while waiting is
      kept and replayed the moment Zapiet is ready, a tap that leads nowhere within 2.5 s is retried (twice), and if
      Zapiet is still not ready 8 s after a tap the shopper is sent to /checkout directly (Shopify's own checkout,
      Standard Shipping, nothing lost but the pickup pre-fill, which only matters when a store was chosen).
   Zapiet builds the URL in window.Zapiet.Helpers.getCheckoutFormUrl (via this.encodeUrlParams) and stores it in
   window.ZapietCheckoutUrl, window.ZapietWidgetConfig.checkout_url and the cart form's action; all of those are
   cleaned, both when built and again at tap time. Remove this block to go back to Zapiet's behaviour. */
(function () {
  'use strict';
  var SEL = 'button[name="checkout"], input[name="checkout"]';
  var RETRY_AFTER = 2500, GIVE_UP_AFTER = 8000, MAX_RETRIES = 2;
  var navigating = false, pending = null;

  function shopLocale() {
    var l = window.Shopify && window.Shopify.locale;
    return (typeof l === 'string' && l) ? l : 'en';
  }
  function isShippingUrl(u) {
    var m = /[?&]method=([^&]*)/.exec(u);
    return !m || decodeURIComponent(m[1]) === 'shipping';
  }
  // Strip the Shop Pay skip on shipping checkouts and force the shop locale, in a URL string.
  function cleanUrl(u) {
    if (typeof u !== 'string' || u.indexOf('?') === -1) return u;
    var out = u;
    if (isShippingUrl(out)) out = out.replace(/([?&])skip_shop(?:ify)?_pay=[^&]*(&|$)/g, function (all, sep, tail) { return tail ? sep : ''; });
    out = out.replace(/([?&])locale=[^&]*/g, '$1locale=' + encodeURIComponent(shopLocale()));
    return out.replace(/[?&]$/, '');
  }
  function cleanParams(p) {
    if (!p || typeof p !== 'object') return p;
    try {
      if (!p.method || p.method === 'shipping') { delete p.skip_shopify_pay; delete p.skip_shop_pay; }
      if (Object.prototype.hasOwnProperty.call(p, 'locale')) p.locale = shopLocale();
    } catch (e) { /* leave Zapiet's object alone */ }
    return p;
  }
  // Clean every place Zapiet keeps the checkout URL. Safe to call often.
  function cleanStored() {
    try {
      if (typeof window.ZapietCheckoutUrl === 'string') window.ZapietCheckoutUrl = cleanUrl(window.ZapietCheckoutUrl);
      var cfg = window.ZapietWidgetConfig;
      if (cfg) { if (typeof cfg.checkout_url === 'string') cfg.checkout_url = cleanUrl(cfg.checkout_url); cleanParams(cfg.url_params); }
      var forms = document.querySelectorAll('form[action*="/checkout"], form#cart, cart-drawer form, form[action*="/cart"]'), i, a;
      for (i = 0; i < forms.length; i++) { a = forms[i].getAttribute('action'); if (a && a.indexOf('?') !== -1) forms[i].setAttribute('action', cleanUrl(a)); }
    } catch (e) { /* never block the tap */ }
  }
  function wrapZapiet() {
    var H = window.Zapiet && window.Zapiet.Helpers;
    if (!H) return false;
    if (H.__siWrapped) return true;
    if (typeof H.encodeUrlParams === 'function') {
      var enc = H.encodeUrlParams;
      H.encodeUrlParams = function (params) { cleanParams(params); return enc.apply(this, arguments); };
    }
    if (typeof H.getCheckoutFormUrl === 'function') {
      var get = H.getCheckoutFormUrl;
      H.getCheckoutFormUrl = function () {
        var r = get.apply(this, arguments);
        if (r && typeof r.then === 'function') return r.then(function (u) { var c = cleanUrl(u); cleanStored(); return c; });
        var c = cleanUrl(r); cleanStored(); return c;
      };
    }
    H.__siWrapped = true;
    return true;
  }
  var wrapTries = 0;
  var wrapTimer = setInterval(function () { if (wrapZapiet() || ++wrapTries > 120) clearInterval(wrapTimer); }, 250);

  // Waiting state on every Check out button until Zapiet says it is ready.
  function ready() { return window.ZapietCheckoutEnabled === true || !window.Zapiet; }
  function paint() {
    var btns = document.querySelectorAll(SEL), i, waiting = !ready();
    for (i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('si-checkout-waiting', waiting);
      if (waiting) btns[i].setAttribute('aria-busy', 'true'); else btns[i].removeAttribute('aria-busy');
    }
  }
  // One paint per frame at most: the drawer, Klaviyo and Swym all mutate the page constantly.
  var paintQueued = false;
  function paintSoon() {
    if (paintQueued) return;
    paintQueued = true;
    (window.requestAnimationFrame || setTimeout)(function () { paintQueued = false; paint(); });
  }
  setInterval(paintSoon, 300);
  if (window.MutationObserver) new MutationObserver(paintSoon).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pagehide', function () { navigating = true; });
  window.addEventListener('beforeunload', function () { navigating = true; });

  function findButton() { var b = document.querySelector('cart-drawer details[open] ' + SEL) || document.querySelector('.cart__ctas ' + SEL) || document.querySelector(SEL); return b; }
  function goDirect() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root.replace(/\/?$/, '/') + 'checkout';
  }
  function watch() {
    if (!pending) return;
    var now = Date.now(), b;
    if (navigating) { pending = null; return; }
    if (!ready()) {
      if (now - pending.at > GIVE_UP_AFTER) { pending = null; goDirect(); return; }
      setTimeout(watch, 300); return;
    }
    b = findButton();
    if (!b) { pending = null; return; }
    if (pending.replay || now - pending.lastTap > RETRY_AFTER) {
      if (pending.tries >= MAX_RETRIES && !pending.replay) { pending = null; return; }
      pending.replay = false; pending.tries += 1; pending.lastTap = now;
      cleanStored();
      pending.ours = true; b.click(); pending.ours = false;
    }
    setTimeout(watch, 300);
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest && ev.target.closest(SEL);
    if (!b || (pending && pending.ours)) return;
    cleanStored();
    if (!ready()) {
      // Zapiet will swallow this tap: keep it and replay it the moment Zapiet is ready.
      pending = { at: Date.now(), lastTap: Date.now(), tries: 0, replay: true };
      b.classList.add('si-checkout-pressed');
      setTimeout(watch, 300);
      return;
    }
    // Zapiet is ready: if nothing happens within 2.5 s (a tap swallowed while it is busy), tap again, at most twice.
    pending = { at: Date.now(), lastTap: Date.now(), tries: 0, replay: false };
    setTimeout(watch, RETRY_AFTER);
  }, true);
})();
